import hasDom from 'has-dom';

/**
 * DOM Animation
 *
 * Will scroll to the top of the page
 *
 */
const DOMAnimation = {
  jumpToTopOfPage() {
    if (hasDom() && !document.scrollingElement) {
      document.scrollingElement = document.documentElement || document.body;
    }
    document.scrollingElement.scrollTop = 0;
  }
};
export default DOMAnimation;